import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Preferences} from '../model/preferences.model';
import {Keys, StorageService} from '../service/storage.service';
import {PreferencesService} from '../service/preferences.service';

@Injectable()
export class InvestmentPreferencesResolver implements Resolve<Preferences | null> {

    private readonly storageService: StorageService;
    private readonly preferencesService: PreferencesService;

    constructor(storageService: StorageService, preferencesService: PreferencesService) {
        this.storageService = storageService;
        this.preferencesService = preferencesService;
    }

    public async resolve(): Promise<Preferences | null> {
        const preferences = await this.preferencesService.getUserPreferences(this.storageService.getItem(Keys.PROFILE_ID), true);
        return preferences ? preferences : null;
    }
}
